import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Calendar.module.css";
import arrow from "./arrow.png";
import { useState, useEffect } from "react";

import MT from "./MT_Calendar_Icon.svg";
import EC from "./EC_Calendar_Icon.svg";

/**
 * A calendar displaying different events. MT is shown on dates for management team meetings and EC is shown on dates for Executive Committee.
 */
export function Calendar({
  events,
  onClickMeeting,
  changeCurrentMonthYear,
  refresh,
  setRefresh,
}) {
  const todaysDate = new Date();

  const [currentMonth, setMonth] = useState(todaysDate.getMonth()); // current month the calendar is on
  const [currentYear, setYear] = useState(todaysDate.getFullYear());
  const [days, setDays] = useState([]); //getDays(currentMonth + 1, currentYear));

  useEffect(() => {
    setDays(getDays(currentMonth + 1, currentYear));
    changeCurrentMonthYear(currentMonth + 1, currentYear);
    setRefresh(false);
  }, [refresh, events, currentMonth, currentYear]);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  function incrementMonth() {
    var nextMonthDate = new Date(currentYear, currentMonth, 1);
    nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
    setMonth(nextMonthDate.getMonth());
    setYear(nextMonthDate.getFullYear());
  }
  function decrementMonth() {
    var lastMonthDate = new Date(currentYear, currentMonth, 1);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
    setMonth(lastMonthDate.getMonth());
    setYear(lastMonthDate.getFullYear());
  }

  function datesAreTheSame(date1, date2) {
    return (
      date1.getMonth() == date2.getMonth() &&
      date1.getDate() == date2.getDate() &&
      date1.getFullYear() == date2.getFullYear()
    );
  }

  function getMeetings(date) {
    var meetings = [];
    for (var i = 0; i < events.length; i++) {
      for (var d = 0; d < events[i].dates.length; d++) {
        if (datesAreTheSame(date, new Date(events[i].dates[d].startsOn))) {
          meetings.push(events[i]);
        }
      }
    }
    return meetings; // returning an array all the meetings on the given date
  }

  function getDays(month, year) {
    var currentDate = new Date(month + "/01/" + year);
    if (currentDate.getDay() != 0) {
      while (currentDate.getDay() != 0) {
        // making sure we start on a sunday
        currentDate.setDate(currentDate.getDate() - 1);
      }
    }

    var d = [];
    for (var i = 0; i < 42; i++) {
      d.push({
        day: currentDate.getDate(),
        month: currentDate.getMonth(),
        year: currentDate.getFullYear(),
        dateString: currentDate.toLocaleDateString(),
        grayedOut: currentDate.getMonth() != month - 1,
        meetings: getMeetings(currentDate),
        today: datesAreTheSame(currentDate, todaysDate),
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return d;
  }

  return (
    <div className={classNames(styles.container)}>
      <div className={classNames(styles.yearMonthContainer)}>
        <span className={classNames(styles.year)}>{currentYear}</span>
        <span className={classNames(styles.month)}>
          {monthNames[currentMonth].toUpperCase()}
        </span>
      </div>

      <div className={styles.arrowContainer}>
        <div
          className={styles.todayText}
          onClick={() => {
            setMonth(todaysDate.getUTCMonth()); // current month the calendar is on
            setYear(todaysDate.getUTCFullYear());
          }}
        >
          Today
        </div>
        <button
          className={styles.arrowImageContainer}
          onClick={() => decrementMonth()}
        >
          <img
            src={arrow}
            className={classNames(styles.arrow, styles.leftArrow)}
          />
        </button>
        <button
          className={classNames(
            styles.arrowImageContainer,
            styles.rightArrowImageContainer
          )}
          onClick={() => incrementMonth()}
        >
          <img
            src={arrow}
            className={classNames(styles.arrow, styles.rightArrow)}
          />
        </button>
      </div>

      <div className={styles.br} />

      <div className={classNames(styles.grid)}>
        <div className={classNames(styles.weekDays)}>SUN</div>
        <div className={classNames(styles.weekDays)}>MON</div>
        <div className={classNames(styles.weekDays)}>TUE</div>
        <div className={classNames(styles.weekDays)}>WED</div>
        <div className={classNames(styles.weekDays)}>THU</div>
        <div className={classNames(styles.weekDays)}>FRI</div>
        <div className={classNames(styles.weekDays)}>SAT</div>

        {days.map((day, index) => (
          <div
            key={day.dateString + index}
            className={classNames(
              styles.gridItem,
              day.grayedOut && styles.grayedOut,
              day.today && styles.todayGridItem
            )}
          >
            <div
              className={classNames(
                day.today && styles.todayTextContainer,
                styles.dayTextContainer
              )}
            >
              {day.day}
            </div>
            {day.meetings.map((meeting, index) => (
              <div key={index}>
                <img
                  onClick={() => onClickMeeting(meeting)}
                  className={styles.meetingIcon}
                  src={meeting.meetingType == "MT" ? MT : EC}
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

Calendar.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  onClickMeeting: PropTypes.func,
  changeCurrentMonthYear: PropTypes.func,
};
